import { RouteRecordRaw } from '@vue-router';
import { configureRoutesMeta } from '@core/utils/configureRoutesMeta'
const routes: Array<RouteRecordRaw> = [
];

export const publicRoutes = configureRoutesMeta(routes, null, 'Public');